import { render } from "./CanvasOverlay.vue?vue&type=template&id=5d2b063a&scoped=true&bindings={\"room\":\"props\",\"plotZone\":\"options\",\"showObstacles\":\"options\",\"plotBlocked\":\"options\",\"testGrid\":\"options\"}"
import script from "./CanvasOverlay.vue?vue&type=script&lang=js"
export * from "./CanvasOverlay.vue?vue&type=script&lang=js"

import "./CanvasOverlay.vue?vue&type=style&index=0&id=5d2b063a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5d2b063a"

export default script